import { render, staticRenderFns } from "./SojaParaguai2022.vue?vue&type=template&id=a3b87a58&lang=pug"
import script from "./SojaParaguai2022.vue?vue&type=script&lang=js"
export * from "./SojaParaguai2022.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports